import createClient from "openapi-fetch";
import type { paths } from "../../../api/generated/openapi";

export const API_BASE =
  process.env.BUN_PUBLIC_API_URL ?? "http://localhost:3002";

export const api = createClient<paths>({
  baseUrl: API_BASE,
});

/**
 * Authenticated fetch wrapper for endpoints that require a Clerk session token.
 * Used for athlete claiming, profile management, and other user-scoped operations.
 */
export async function authFetch<T = unknown>(
  path: string,
  options: {
    method?: string;
    body?: unknown;
    token: string | null;
  },
): Promise<T> {
  const { method = "GET", body, token } = options;
  if (!token) throw new Error("Not authenticated");

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: body != null ? JSON.stringify(body) : undefined,
  });

  const data = await res.json();
  if (!res.ok) {
    throw new Error(
      (data as { message?: string }).message ?? `Request failed (${res.status})`,
    );
  }
  return data as T;
}
